import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";

import Container from "./styled-components/Container";
import Error from "./styled-components/Error";
import StyledInput from "./styled-components/StyledInput";

interface InputProps {
  registerReturn: UseFormRegisterReturn;
  error?: FieldError;
  type?: string;
  placeholder?: string;
}

function Input({ error, registerReturn, ...rest }: InputProps) {
  return (
    <Container>
      <StyledInput {...registerReturn} {...rest} error={Boolean(error)} />
      {Boolean(error?.message) && <Error>{error?.message}</Error>}
    </Container>
  );
}

export default Input;
